'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _curry2 = require('lodash/curry');
var _curry3 = _interopRequireDefault(_curry2);
exports.default = eauors;
var _d = require('d3');
var _d2 = _interopRequireDefault(_d);
var _utils = require('../utils');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function barUpdate(selection, options, accessors) {
  selection.style({
    fill: function fill(datum) {
      return (0, _utils.getColorShade)((0, _utils.getColor)(options, accessors.focusData(datum)), accessors.colorCoeff(datum, options));
    }
  });
}
function rectOrigin(pivot, scale, accessor, datum) {
  return scale(accessor(datum));
}
function rectHeight(pivot, scale, datum) {
  return Math.abs(scale(Math.abs(datum.height)) - scale(pivot));
}
function rectOver(options, accessors, datum) {
  _d2.default.select(this.parentNode).style({
    fill: function fill(datum) {
      return (0, _utils.getColorShade)((0, _utils.getOverColor)(options, accessors.focusData(datum)), accessors.colorCoeff(datum, options));
    }
  });
}
function rectOut(options, accessors, datum) {
  _d2.default.select(this.parentNode).style({
    fill: function fill(datum) {
      return (0, _utils.getColorShade)((0, _utils.getColor)(options, accessors.focusData(datum)), accessors.colorCoeff(datum, options));
    }
  });
}
function rectEnter(selection, options, selectors, accessors, hideTooltip) {
  (0, _utils.setupElement)(selection, 'svg:rect', selectors.rect).on('mouseleave', (0, _curry3.default)(hideTooltip));
}
function rectUpdate(selection, options, accessors, _ref, _ref2, showTooltip) {
  var xScale = _ref.xScale,
    yScale = _ref.yScale;
  var xPivot = _ref2.xPivot,
    yPivot = _ref2.yPivot;
  selection.attr({
    width: xScale.rangeBand(),
    height: (0, _curry3.default)(rectHeight)(yPivot, yScale),
    x: function x(datum) {
      return xScale(accessors.x(datum));
    },
    y: (0, _curry3.default)(rectOrigin)(yPivot, yScale, function (d) {
      return d.height >= 0 ? d.y : d.y0;
    })
  });
  selection.style({
    'stroke-width': accessors.rectStrokeThickness(options.serie),
    stroke: accessors.rectStrokeColor(options.serie),
    'shape-rendering': 'crispEdges'
  });
  selection.on('mouseover', (0, _curry3.default)(rectOver)(options.serie, accessors)).on('mouseout', (0, _curry3.default)(rectOut)(options.serie, accessors)).on('mousemove', function (datum) {
    var serie = _d2.default.select(this.parentNode.parentNode).datum();
    showTooltip(options.serie, {
      xScale: xScale,
      yScale: yScale
    }, serie, datum);
  });
}
function eauors(target) {
  target.eauors = (0, _extends3.default)({}, target.eauors, {
    barUpdate: barUpdate,
    rectEnter: rectEnter,
    rectUpdate: rectUpdate
  });
}